import { render, staticRenderFns } from "./BaseFrontOfficeDataTable.vue?vue&type=template&id=aa5bce6c"
import script from "./BaseFrontOfficeDataTable.vue?vue&type=script&lang=js"
export * from "./BaseFrontOfficeDataTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})
